module.exports = __webpack_public_path__ + "fonts/UniSansRegular.79fc0798.ttf";